import { BellIcon } from "@heroicons/react/24/outline";
import { hasOverdueReminders } from "@sp-crm/core";
import { ReminderContext } from "contexts/reminder";
import React, { useCallback, useContext } from "react";

export const ReminderTrayItem: React.FC = () => {
    const { isReminderEnabled, setVisible, reminders } = useContext(ReminderContext);
    const remindersCount = reminders?.length || 0;
    const hasOverdue = hasOverdueReminders(reminders || [], new Date());

    const handleClick = useCallback(() => {
        setVisible(true);
    }, [setVisible]);

    if (!isReminderEnabled) {
        return null;
    }

    const badgeLabel = remindersCount > 99 ? "99+" : remindersCount.toString();

    return (
        <button
            onClick={handleClick}
            data-reminder-bell
            className="relative p-1.5 rounded-lg hover:bg-zinc-950/5 dark:hover:bg-white/5 focus:outline-none"
            aria-label={
                remindersCount > 0
                    ? `Reminders (${remindersCount}${hasOverdue ? ", some overdue" : ""})`
                    : "Reminders"
            }>
            <BellIcon className="size-5 text-zinc-500" />
            {remindersCount > 0 && (
                <span
                    className={`absolute -top-0.5 -right-0.5 flex h-3.5 min-w-3.5 items-center justify-center rounded-full px-0.5 text-[9px] font-semibold leading-none text-white animate-pulse ${
                        hasOverdue ? "bg-red-500" : "bg-amber-500"
                    }`}>
                    {badgeLabel}
                </span>
            )}
        </button>
    );
};
